import { useState } from "react"
import Detail from "../../components/Modal/Detail"
import { modalHandle } from "../../core"
import AppRoutes from "../../routes"
import "./styles.css"

const Default = () => {
  const [modalContent, setModalContent] = useState()

  return (
    <div className="default-container">
      <div className="modal" onClick={() => modalHandle("close")}>
        <div className="modal-box" onClick={(event) => event.stopPropagation()}>
          <Detail content={modalContent} />
        </div>
      </div>
      <AppRoutes setModalContent={setModalContent} />
    </div>
  )
}

export default Default
